//船运大详情--船舶

import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 换档类型
 */
class GearShiftType extends UltMeta {
    UPPER_GEAR = new Meta(0, "上档");
    GEAR_SHIFT = new Meta(1, "接档");
    MAKE_FILE = new Meta(2, "让档");
}

export const GEAR_SHIFT_TYPE = new GearShiftType();
